import React from "react";
import { Alert, Button, Modal, Table } from "antd";
import { useTranslation } from "react-i18next";
import { formatSyncValue } from "functions/productData";

/**
 * Someone else changed this product while the drawer was open.
 *
 * `cms/` is still running next to this CMS and writes the whole product document, so this is a
 * real situation and not a race to shrug at. The save is refused, and the user is shown exactly
 * which values moved and to what - then chooses: take over what is stored now, or overwrite it
 * on purpose. There is no silent third option.
 */
const StaleWriteModal = ({ open, staleFields, busy, onReload, onOverwrite, onClose }) => {
  const { t } = useTranslation();

  const columns = [
    { title: t("product_data.field"), dataIndex: "label", key: "label" },
    {
      title: t("product_data.value_when_opened"),
      key: "loaded",
      render: (_, field) => formatSyncValue(field.key, field.loaded),
    },
    {
      title: t("product_data.value_now"),
      key: "current",
      render: (_, field) => <strong>{formatSyncValue(field.key, field.current)}</strong>,
    },
  ];

  return (
    <Modal
      open={open}
      width={620}
      onCancel={onClose}
      maskClosable={false}
      title={t("product_data.stale_title")}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={busy}>
          {t("cancel")}
        </Button>,
        <Button key="overwrite" danger loading={busy} onClick={onOverwrite}>
          {t("product_data.stale_overwrite")}
        </Button>,
        <Button key="reload" type="primary" disabled={busy} onClick={onReload}>
          {t("product_data.stale_reload")}
        </Button>,
      ]}
    >
      <Alert type="warning" showIcon className="mb-3" message={t("product_data.stale_description")} />

      <Table
        size="small"
        pagination={false}
        rowKey="key"
        columns={columns}
        dataSource={staleFields || []}
      />
    </Modal>
  );
};

export default StaleWriteModal;
